import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import IMerchantState from "@/types/merchant";

export default {
  namespaced: true,
  state: {
    jwt: null,
    merchant: null,
    merchantFlags: [],
    notices: [],
    experiments: undefined,
    featureFlags: undefined,
    geolocationAllowed: false,
    geolocationCheckInProgress: false,
    geolocationCheckDone: false,
    geolocationActions: {},
  } as IMerchantState,
  actions,
  getters,
  mutations,
};
